import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
import "bootstrap/dist/js/bootstrap.min.js";
import CartProvider from './store/CartProvider';
import { Provider } from 'react-redux';
import { store, persistor  } from './redux/configureStore';
import { PersistGate } from 'redux-persist/integration/react'
import {createStore} from 'redux'
import rootReducer from './reducers';
import "react-multi-carousel/lib/styles.css";

const store1 = createStore(rootReducer)


ReactDOM.render(
     
  <React.StrictMode>
    <Provider store={store1}>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <CartProvider>
    <App />
    </CartProvider>
    </PersistGate>
    </Provider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
